import type { ReasonOrigin } from "common/types/reasons";

type ENTITY_ACTIONS =
  | "created"
  | "updated"
  | "restored"
  | "archived"
  | "closed"
  | "opened";

type EXTERNAL_TRIGGERS_ACTIONS =
  | "recalculate API"
  | "tenant activation"
  | "trigger-microservices command";

export const ACTION_MAP: Partial<Record<ReasonOrigin, ENTITY_ACTIONS>> = {
  ScheduledWorkOrderCreated: "created",
  ScheduledWorkOrderAssetsCreated: "created",
  ScheduledWorkOrderUpdated: "updated",
  ScheduledWorkOrderAssetsUpdated: "updated",
  ScheduledWorkOrderRestored: "restored",
  ScheduledWorkOrderArchived: "archived",
  WorkOrderArchived: "archived",
  WorkOrderClosed: "closed",
  WorkOrderEarlyOpened: "opened",
  WorkOrderOpenedOnScheduledDate: "opened",
};

export const EXTERNAL_TRIGGER_MAP: Partial<
  Record<ReasonOrigin, EXTERNAL_TRIGGERS_ACTIONS>
> = {
  RecalculationFromApi: "recalculate API",
  TenantActivated: "tenant activation",
  TriggerMicroservices: "trigger-microservices command",
};
